<template>
	<div class="grid grid-rows-1 grid-flow-col gap-4">
		<div>
			<p class="mb-0 text-sm text-left" style="color:#63b3ed;">
				{{ options.label }}
			</p>
			<p
				class="mb-0 text-left text-5xl sm:text-2xl md:text-5xl lg:text-5xl xl:text-5xl font-semibold"
				:style="'color:' + color() + ';'"
			>
				{{ value()
				}}<span style="color:#bdbdbd;">{{ options.unit }}</span>
			</p>
		</div>
	</div>
</template>
<script>
export default {
	name: 'MTextVertical',
	props: {
		data: {
			type: Array,
			default: () => {
				return []
			}
		},
		options: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	methods: {
		color() {
			if ('color' in this.options) {
				return this.options.color
			} else return '#757575'
		},
		value() {
			if (this.data.length > 0) {
				return this.data[0][this.options.value]
			}
			return 0
		}
	}
}
</script>
